module.exports = __webpack_public_path__ + "img/acc-mic.0f3b638a.png";